import React from 'react';
import config from 'client/shared/config';
import { NavLink } from 'react-router-dom';

export default class GenreRow
extends React.Component {
	render () {
		const { artwork, label, _id, gradientInfo } = this.props;

	
		let colorInfo = gradientInfo.find(l=>l.label === label);
		const styles = {
			display: 'block',
			// backgroundImage: `url("${config.paths.imgBasePath}/${artwork}")`
			background: `linear-gradient(to right, ${colorInfo.start} 6%, ${colorInfo.end} 45%)`
		};

		return (
			<NavLink
				className="primary-font playlist-tile-label"
				// style={ styles }
				to={ `/browse/genres/${_id}` }
			>
					{ label }
			</NavLink>
		);
	}
}
